<template>
  <div id="app">
    <Navigation v-if="currentUser"></Navigation>
    <router-view />
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import Navigation from "./components/nav";

  export default {
    components: { Navigation },
    computed: {
      ...mapState(['currentUser'])
    }
  }
</script>

<style>
@font-face {
  font-family: "Avenir";
  src: url("assets/fonts/Avenir-Roman.woff2") format("woff2");
}

@font-face {
  font-family: "Avenir Heavy";
  src: url("assets/fonts/Avenir-Heavy.woff2") format("woff2");
}


html {
  background-color: #e1dfdf;
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 20px;
  font-size: 14px;
}

a {
  text-decoration: none;
  color: #2c3e50;
}

ul {
  list-style-type: none;
}

h2 {
  font-size: 18px;
}

h5 {
  margin: 5px;
}

.bs-card {
  flex: 0 1 30%;
  background-color: lightgrey;
  padding: 10px;
  border-radius: 3px;
  margin: 20px 20px 0px 0;
}

.button {
  padding: 7px 15px;
  background: #2c3e50;
  color: #fff;
  font-size: 0.8em;
  cursor: pointer;
  font-family: "Avenir Heavy", Helvetica, Arial, sans-serif;
  border-radius: 100px;
  border: 1px solid #2c3e50;
  transition: 0.3s;
  outline: none;
}

.button:hover {
  border: 1px solid #2c3e50;
  color: #2c3e50;
  background: transparent;
}

textarea {
  border: none;
  width: 100%;
}
</style>

